// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"f898f765","453":"14f7f4b7","958":"7adf0a4d"}[chunkId] + ".chunk.js";
};